import { Link } from 'react-router-dom';
import { Home, LogOut, Star, Shield, GraduationCap } from 'lucide-react';
import { useAuth } from '../App';
import NotificationBell from './NotificationBell';
import FamilyProfileSwitcher from './FamilyProfileSwitcher';

const Header = () => {
  const { user, logout, refreshUser } = useAuth();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <Home className="w-7 h-7 text-coral-orange" />
          <span className="font-display text-2xl font-bold">
            <span className="text-mint-green">Type</span>
            <span className="text-coral-orange">Town</span>
          </span>
        </Link>
        
        <div className="flex items-center gap-4">
          {/* Admin Link */}
          {(user?.is_admin || user?.email === 'clare@bluecactus.digital') && (
            <Link
              to="/admin"
              className="flex items-center gap-2 text-amber-600 hover:text-amber-700 transition-colors"
            >
              <Shield className="w-5 h-5" />
              <span className="hidden sm:inline font-medium">Admin</span>
            </Link>
          )}
          
          {/* Teacher Dashboard Link */}
          {user?.user_type === 'teacher' && (
            <Link
              to="/teacher/dashboard"
              className="flex items-center gap-2 text-sky-blue hover:text-sky-600 transition-colors"
            >
              <GraduationCap className="w-5 h-5" />
              <span className="hidden sm:inline font-medium">Class</span>
            </Link>
          )}
          
          {/* Family Profile Switcher */}
          {user && <FamilyProfileSwitcher currentUser={user} onProfileSwitch={refreshUser} />}
          
          {user && (
            <>
              <div className="flex items-center gap-2 bg-sunny-yellow/20 rounded-full px-4 py-2 border-2 border-sunny-yellow">
                <Star className="w-5 h-5 text-sunny-yellow fill-sunny-yellow" />
                <span className="font-bold text-text-dark">{user?.credits || 0}</span>
                <span className="text-xs text-text-medium">coins</span>
              </div>
              <NotificationBell />
              <button
                onClick={logout}
                className="text-text-medium hover:text-coral-orange transition-colors p-2 rounded-full hover:bg-coral-orange/10"
              >
                <LogOut className="w-5 h-5" />
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;
